import EventEmitter from 'eventemitter3';
import { Scene } from "../../tools/Scene";
import { Button } from "../../ui/Button";
import { LocalizationManager } from '../../managers/LocalizationManager';
import { HTPScene } from './HTPScene';

export class HTPContainerScene extends Scene{

    container:Phaser.GameObjects.Image|null = null;
    containerLabel:Phaser.GameObjects.Text|null = null;
    containerHTP:Phaser.GameObjects.Image|null = null;
    containerText:Phaser.GameObjects.Text|null = null;

    htpScene:HTPScene|null = null;

    playButton:Button|null = null;

    emitter:EventEmitter = new EventEmitter();
    group:Phaser.GameObjects.Group|null = null;
    blackScreen:Phaser.GameObjects.Image|null = null;

    open:boolean = false;
    htpIndexLength:number;
    
    constructor(sceneConfig,htpIndexLength:number){
        super(sceneConfig);
        this.htpIndexLength = htpIndexLength;
    }
    
    prescaleCreate(){

        let position;
        let style;
        let button:Button;
        let text;
        let textString;
        let image:Phaser.GameObjects.Image;
        let group = this.add.group({});
        this.group = group;

        position = this.scaleManager.getRelativePosition(.5,.5);
        image = this.add.image(position.x,position.y,'gen_overlay');
        image.setAlpha(0.5);
        image.setTint(0x000000);
        image.setInteractive();
        this.blackScreen = image;

        position = this.scaleManager.getRelativePosition(0.5,0.5,true);
        image = this.add.image(position.x,position.y,'gfx_pop');
        group.add(image);
        this.container = image;

        text= this.add.text(position.x - 570,position.y - 260,LocalizationManager.getText('HOW_TO_PLAY'),LocalizationManager.getStyle('HOW_TO_PLAY'));
        text.setOrigin(0,1);
        group.add(text);
        this.containerLabel = text;

        let htpScene = new HTPScene(this,position,this.htpIndexLength);
        group.addMultiple(htpScene.group.getChildren());
        this.htpScene = htpScene;

        button = new Button(this,'play_button',position.x,position.y+300);
        button.buttonPressedSprite = 'play_button_pressed';
        button.buttonHighlightSprite = 'play_button';
        button.emitter.on('buttonup',this.startClose,this);
        group.addMultiple(button.group.getChildren());
        this.playButton = button;

        //Init

        //Add Scene event bindings
        this.events.on('resize',this.onSceneResize,this);
    }
    
    reorient(landscape:boolean){
        let position;
        if(landscape){
            if(this.htpScene){
                this.htpScene.reorient(landscape);
            }
            if(this.container){
                position = this.scaleManager.getRelativePosition(0.5,0.5,true);
                this.container!.setPosition(position.x,position.y);
                this.containerLabel!.setPosition(position.x-305,position.y-140);
                Phaser.Actions.SetXY(this.playButton!.group.getChildren(),position.x,position.y+160);
                if(this.open){
                    let origin = this.container.y;
                    let destination = position.y;
                    Phaser.Actions.IncY(this.group!.getChildren(),-(origin - (destination)));
                }else{
                    let origin = this.container.y;
                    let destination = position.y-2000;
                    Phaser.Actions.IncY(this.group!.getChildren(),-(origin - (destination)));
                }
            }
            if(this.blackScreen){
                position = this.scaleManager.getRelativePosition(.5,.5);
                this.blackScreen.setPosition(position.x,position.y);
                // this.blackScreen.setTexture('lan_gen_bg');
                this.input.setHitAreaFromTexture(this.blackScreen,undefined);
            }
            
        }else{
            if(this.htpScene){
                this.htpScene.reorient(landscape);
            }
            if(this.container){
                position = this.scaleManager.getRelativePosition(0.5,0.5,true);
                this.container!.setPosition(position.x,position.y);
                this.containerLabel!.setPosition(position.x-305,position.y-140);
                Phaser.Actions.SetXY(this.playButton!.group.getChildren(),position.x,position.y+160);
                if(this.open){
                    let origin = this.container.y;
                    let destination = position.y;
                    Phaser.Actions.IncY(this.group!.getChildren(),-(origin - (destination)));
                }else{
                    let origin = this.container.y;
                    let destination = position.y-2000;
                    Phaser.Actions.IncY(this.group!.getChildren(),-(origin - (destination)));
                }
            }
            if(this.blackScreen){
                position = this.scaleManager.getRelativePosition(0.5,0.5,true);
                position = this.scaleManager.getRelativePosition(.5,.5);
                this.blackScreen.setPosition(position.x,position.y);
                // this.blackScreen.setTexture('por_gen_bg');
                this.input.setHitAreaFromTexture(this.blackScreen,undefined);
            }
            
        }
        this.rescaleBackground();
    }

    rescaleBackground():void {
        //rescale background
        let ratio = this.scaleManager.getRatio();

        if(this.blackScreen!.width * this.blackScreen!.scaleX != window.innerWidth || this.blackScreen!.height * this.blackScreen!.scaleY != window.innerHeight)
        {
            this.blackScreen!.setScale(this.sys.canvas.width/this.blackScreen!.width / ratio! , this.sys.canvas.height/this.blackScreen!.height / ratio!);
        }
    }

    startOpen(){
        this.open = true;
        this.scene.bringToTop(undefined!);
        this.blackScreen!.setVisible(true);
        let origin = this.container!.y;
        let destination = this.scaleManager.getRelativePosition(0.5,0.5,true);
        this.tweens.add({
            targets : this.group!.getChildren(),
            y: '+=' + (-(origin - destination.y)),
            duration: .5 * 1000,
            ease: 'Power3'
        });
    }
    
    startClose(){
        this.open = false;
        this.blackScreen!.setVisible(false);
        this.emitter.emit('close');
        this.tweens.add({
            targets : this.group!.getChildren(),
            y: '+=-2000',
            duration: 1 * 1000,
            ease: 'Power3',
            onComplete:this.onCloseComplete,
            onCompleteParams: [this]
        });
    }

    onSceneResize()
    {
        this.rescaleBackground();
    }

    
    onCloseComplete(tween,targets,scene){
        scene.scene.sendToBack(undefined!);
    }
}